import axios from "axios";

const baseUrl = `${process.env.REACT_APP_GITO_API_URL}/bookings/booking`;
const bookingLocationBaseUrl = `${process.env.REACT_APP_GITO_API_URL}/bookings/bookinglocation`;
const bookingTermsBaseUrl = `${process.env.REACT_APP_GITO_API_URL}/bookings/bookingterms`;
 //const baseUrl = "https://localhost:7241/booking";
 //const bookingLocationBaseUrl = "https://localhost:7241/bookinglocation";
 //const bookingTermsBaseUrl = "https://localhost:7241/bookingterms";

const authHeaders = (apiAccessToken) => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${apiAccessToken}`,
});

const getErrorMessage = (error, fallback) =>
  error?.response?.data?.detail ||
  error?.response?.data?.message ||
  error?.response?.data?.errorDescription ||
  fallback;

export async function getBookingOverview(apiAccessToken, viewStart, viewEnd) {
  try {
    const response = await axios.get(`${baseUrl}/get-booking-overview`, {
      headers: authHeaders(apiAccessToken),
      params: {
        viewStart,
        viewEnd,
      },
    });

    return response.data;
  } catch (error) {
    throw new Error(getErrorMessage(error, "Failed to fetch booking overview"));
  }
}

export async function getMyBookings(apiAccessToken, viewStart, viewEnd) {
  try {
    const response = await axios.get(`${baseUrl}/get-my-bookings`, {
      headers: authHeaders(apiAccessToken),
      params: {
        viewStart,
        viewEnd,
      },
    });

    return response.data;
  } catch (error) {
    throw new Error(getErrorMessage(error, "Failed to fetch my bookings"));
  }
}

export async function getAvailableConnectors(
  chargingSitePublicId,
  apiAccessToken,
  start,
  end,
  excludeBookingPublicId,
  bookingType
) {
  try {
    const response = await axios.get(
        `${baseUrl}/get-available-connectors-for-booking/${chargingSitePublicId}`,
      {
        headers: authHeaders(apiAccessToken),
        params: {
          start,
          end,
          excludeBookingPublicId,
          bookingType,
        },
      }
    );

    return response.data;
  } catch (error) {
    if (error?.response?.status === 404) {
      return [];
    }

    throw new Error(getErrorMessage(error, "Failed to fetch available connectors"));
  }
}

export async function getAvailableConnectorDetails(chargingConnectorPublicId, apiAccessToken) {
  try {
    const response = await axios.get(
      `${baseUrl}/get-available-connector-details-for-booking/${chargingConnectorPublicId}`,
      {
        headers: authHeaders(apiAccessToken),
      }
    );

    return response.data;
  } catch (error) {
    throw new Error(getErrorMessage(error, "Failed to fetch connector details"));
  }
}

export async function getBooking(bookingPublicId, apiAccessToken) {
  try {
    const response = await axios.get(`${baseUrl}/get-booking/${bookingPublicId}`, {
      headers: authHeaders(apiAccessToken),
    });

    return response.data;
  } catch (error) {
    throw new Error(getErrorMessage(error, "Failed to fetch booking"));
  }
}

export async function createBooking(payload, apiAccessToken) {
  try {
    const response = await axios.post(`${baseUrl}/create-booking`, payload, {
      headers: authHeaders(apiAccessToken),
    });

    return response.data;
  } catch (error) {
    throw new Error(getErrorMessage(error, "Failed to create booking"));
  }
}

export async function cancelBooking(bookingPublicId, payload, apiAccessToken) {
  try {
    const response = await axios.post(
      `${baseUrl}/cancel-booking/${bookingPublicId}`,
      payload,
      {
        headers: authHeaders(apiAccessToken),
      }
    );

    return response.data;
  } catch (error) {
    throw new Error(getErrorMessage(error, "Failed to cancel booking"));
  }
}

export async function updateBooking(bookingPublicId, payload, apiAccessToken) {
  try {
    const response = await axios.put(
      `${baseUrl}/update-booking/${bookingPublicId}`,
      payload,
      {
        headers: authHeaders(apiAccessToken),
      }
    );

    return response.data;
  } catch (error) {
    throw new Error(getErrorMessage(error, "Failed to update booking"));
  }
}

export async function getBookingLocations(apiAccessToken) {
  try {
    const response = await axios.get(`${bookingLocationBaseUrl}/get-booking-locations`, {
      headers: authHeaders(apiAccessToken),
    });

    return response.data;
  } catch (error) {
    throw new Error(getErrorMessage(error, "Failed to fetch booking locations"));
  }
}

export async function getBookingTerms(bookingLocationPublicId, apiAccessToken) {
  try {
    const response = await axios.get(
      `${bookingTermsBaseUrl}/get-booking-terms/${bookingLocationPublicId}`,
      {
        headers: authHeaders(apiAccessToken),
      }
    );

    return response.data;
  } catch (error) {
    throw new Error(getErrorMessage(error, "Failed to fetch booking terms"));
  }
}

export async function updateBookingTerms(payload, apiAccessToken) {
  try {
    const response = await axios.put(`${bookingTermsBaseUrl}/update-booking-terms`, payload, {
      headers: authHeaders(apiAccessToken),
    });

    return response.data;
  } catch (error) {
    throw new Error(getErrorMessage(error, "Failed to update booking terms"));
  }
}
